import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Table } from "react-bootstrap";
import { nutritionFactsTable } from "../firebase/content";
import Editable from "./Editable";
import EditableImage from "./EditableImage";

class NutritionFacts extends React.Component {
  render() {
    let { editable } = this.props;
    let { [nutritionFactsTable]: nutritionFacts } = this.props.content;
    nutritionFacts = nutritionFacts || {};
    return (
      <EditableImage
        editable={editable}
        object={nutritionFacts}
        field="background"
      >
        {({ url, select }) => (
          <div
            className="nutrition-section"
            id="nutrition-facts"
            style={{
              backgroundImage: "url(" + url + ")",
            }}
            onClick={select}
          >
            <Container className="nutrition-section-content">
              <Row className="nutrition-section-intro">
                <Col onClick={(e) => e.stopPropagation()}>
                  <section>
                    <h1>Sức hấp dẫn của Macadamia </h1>
                    {(nutritionFacts.text || []).map((text) => {
                      return (
                        <Editable
                          editable={editable}
                          key={text.id}
                          object={text}
                          field="line"
                        >
                          <p>{text.line}</p>
                        </Editable>
                      );
                    })}
                  </section>
                </Col>
              </Row>
              <Row className="nutrition-table-intro">
                <Col onClick={(e) => e.stopPropagation()}>
                  <section>
                    <h2>Giá trị dinh dưỡng</h2>
                    <p>
                      Hạt mắc ca tươi, tính trên 100 gam <br />
                      Giá trị dinh dưỡng cho mỗi 100 g (3,5 oz)
                    </p>
                  </section>
                </Col>
              </Row>
              <Container className="nutrition-table-content">
                <Row>
                  <Col
                    className="nutrition-table-1"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Table size="sm">
                      <thead>
                        <tr>
                          <th>Thành phần</th>
                          <th>Hàm lượng</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Năng lượng</strong>
                          </td>
                          <td>3,080 kJ (740 kcal)</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Carbohydrates</strong>
                          </td>
                          <td>13.8 g</td>
                        </tr>
                        <tr>
                          <td>Đường</td>
                          <td>4.57 g</td>
                        </tr>
                        <tr>
                          <td>Chất xơ</td>
                          <td>8.6 g</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Chất béo</strong>
                          </td>
                          <td>75.8 g</td>
                        </tr>
                        <tr>
                          <td>Chất béo bão hòa</td>
                          <td>12 g</td>
                        </tr>
                        <tr>
                          <td>Chất béo chưa bão hòa</td>
                          <td>59 g</td>
                        </tr>
                        <tr>
                          <td>Chất béo chưa bão hòa đa</td>
                          <td>1.5 g</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Chất đạm</strong>
                          </td>
                          <td>7.9 g</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col
                    className="nutrition-table-2"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Table size="sm">
                      <thead>
                        <tr>
                          <th>Thành phần</th>
                          <th>Hàm lượng</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Vitamin</strong>
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>B1</td>
                          <td>1.195 mg</td>
                        </tr>
                        <tr>
                          <td>B2</td>
                          <td>0.162 mg</td>
                        </tr>
                        <tr>
                          <td>B3</td>
                          <td>2.473 mg</td>
                        </tr>
                        <tr>
                          <td>B5</td>
                          <td>0.76 mg</td>
                        </tr>
                        <tr>
                          <td>B6</td>
                          <td>0.275 mg</td>
                        </tr>
                        <tr>
                          <td>B9</td>
                          <td>11 μg</td>
                        </tr>
                        <tr>
                          <td>Vitamin C</td>
                          <td>1.2 mg</td>
                        </tr>
                        <tr>
                          <td>Vitamin E</td>
                          <td>0.54 mg</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col
                    className="nutrition-table-3"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Table size="sm">
                      <thead>
                        <tr>
                          <th>Thành phần</th>
                          <th>Hàm lượng</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Khoáng chất</strong>
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Canxi</td>
                          <td>85 mg</td>
                        </tr>
                        <tr>
                          <td>Sắt</td>
                          <td>3.69 mg</td>
                        </tr>
                        <tr>
                          <td>Ma giê</td>
                          <td>130 mg</td>
                        </tr>
                        <tr>
                          <td>Manga</td>
                          <td>4.1 m</td>
                        </tr>
                        <tr>
                          <td>Kali</td>
                          <td>188 mg</td>
                        </tr>
                        <tr>
                          <td>Kẽm</td>
                          <td>1.30 mg</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col md={12} onClick={(e) => e.stopPropagation()}>
                    Nguồn:{" "}
                    <a href="https://en.wikipedia.org/wiki/Macadamia">
                      Wikipedia
                    </a>
                  </Col>
                </Row>
              </Container>
            </Container>
          </div>
        )}
      </EditableImage>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    images: state.images,
  };
};

export default connect(mapStateToProps)(NutritionFacts);
